export class MOesWorkspaceService {

    private static instance = new MOesWorkspaceService();
    private _allowInventoryManagement: boolean;

    public static getInstance() {
        return this.instance;
    }

    private constructor() {
        this._allowInventoryManagement = false;
    }

    public setInventoryManagement(allowInventoryManagement: boolean) {
        this._allowInventoryManagement = allowInventoryManagement;
    }

    public get allowInventoryManagement() {
        return this._allowInventoryManagement;
    }

}



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/modules/mobile/services/m-oes-workspace.service.ts